import { capitalizeFirstLetter } from '@repo/ui/utils';
import { buildImageProxyUrl } from '@repo/utils/url';

import { CreateFirstUseCase, TransformedUseCase } from './types';

export const getUseCaseCoverImage = (useCase: TransformedUseCase): string => {
  if (useCase.imagePaths?.categoryPageImage) {
    return buildImageProxyUrl(`api/${useCase.imagePaths.categoryPageImage}`, {
      keepFormat: true,
    });
  }
  return useCase.imagePaths?.localImage ?? '/images/category/all-new.png';
};

export const transformToCreateFirstUseCase = (
  useCase: TransformedUseCase
): CreateFirstUseCase => {
  return {
    slug: useCase.slug,
    name: useCase.name,
    type: 'useCase',
    imagePath: getUseCaseCoverImage(useCase),
  };
};

export const filterUseCasesByQuery = (
  useCases: CreateFirstUseCase[],
  query: string
): CreateFirstUseCase[] => {
  const trimmedQuery = query.trim();
  const result = useCases
    .filter((useCase) =>
      useCase.name.toLowerCase().includes(trimmedQuery.toLowerCase())
    )
    .slice(0, 10);

  if (trimmedQuery && result.length === 0) {
    result.push(getUseCaseQuery(trimmedQuery));
  }
  return result;
};

const getUseCaseQuery = (query: string): CreateFirstUseCase => ({
  slug: query,
  name: capitalizeFirstLetter(query),
  type: 'search',
  imagePath: '/images/category/plain-doc.png',
});
